import type { AlgoliaAutocompleteHit } from "@/types/AlgoliaAutocompleteHit.ts";
import type { AutocompletePlugin } from "@algolia/autocomplete-core";
import { getAlgoliaResults } from "@algolia/autocomplete-preset-algolia";
import type {LiteClient} from "algoliasearch/lite";

export const useContentPlugin = (searchClient: LiteClient,algoliaContentSearchIndexName:string, autocompleteContentHits:number) => {
	const contentPlugin: AutocompletePlugin<AlgoliaAutocompleteHit, {}> = {
		getSources({ query }) {
			if (!query) {
				return [];
			}
			return [
				{
					sourceId: "contentPlugin",
					getItems() {
						return getAlgoliaResults({
							searchClient,
							queries: [
								{
									indexName: algoliaContentSearchIndexName ?? "",
									params: {
										query,
										hitsPerPage: autocompleteContentHits ?? 4,
										attributesToSnippet: ["content:4"],
										snippetEllipsisText: "…",
									},
								},
							],
						});
					},
				},
			];
		},
	};
	return contentPlugin;
};
